export default {
    baseStyle: {
        '--skeleton-start-color': 'dimGray',
        '--skeleton-end-color': 'shadyGray',
        background: 'darkGray',
        opacity: 0.3
    }
}
